import { Base, Component } from '@/vue-property-decorator'
import { gameHelper } from '@/views/game/services'
import { useMainStore } from '@/store/index'
import ComponentsManager, {
  ConfigType,
  ThemeComponentType
} from '@/context/components-manager'
import Render from '@/components/business-components/func-render/async-component'
import Skin from '@/controller/Skin'
import style from './styles/style.module.scss'
@Component<FloatBar>({
  name: 'FloatBar',
  components: (() => {
    return {
      ...ComponentsManager.register({
        namespace: ConfigType.Theme,
        moduleType: ThemeComponentType.FloatBar
      }),
      FastEntry: Render.createAsyncComponent({
        component: () => import('./components/fastEntry')
      })
    }
  })()
})
export default class FloatBar extends Base {
  /**
   * 动态计算当前渲染的组件名
   */
  private get renderFloatBarComponentsName() {
    return ComponentsManager.getName({
      namespace: ConfigType.Theme,
      moduleType: ThemeComponentType.FloatBar,
      key: Skin.skinType
    })
  }

  get showFloatBar() {
    const { isWeb } = useMainStore()
    return isWeb || (!isWeb && gameHelper.isHomePage)
  }

  render() {
    return (
      <div class={[style.floatBox, 'floatBox']}>
        <fast-entry v-show={gameHelper.isHomePage} class={style.fastEntry} />
        {this.showFloatBar && (
          <this.renderFloatBarComponentsName
            {...{
              attrs: {
                'data-components-name': this.renderFloatBarComponentsName
              }
            }}
          />
        )}
      </div>
    )
  }
}
